<template>
  <el-popover
    placement="bottom"
    width="324"
    popper-class="dashboard-budget"
    v-model="visible">
    <p class="title">
      <span>修改账户日预算</span>
      <i class="el-icon-close" @click="close"></i>
    </p>
    <el-form :model="budgetData" size="small" :rules="rules" ref="budgetForm">
      <el-form-item prop="type" class="mini-bottom">
        <el-radio-group v-model="budgetData.type">
          <el-radio :label="0">不限</el-radio>
          <el-radio :label="1">自定义</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="budget" v-if="budgetData.type === 1">
        <el-input v-model.number="budgetData.budget"></el-input>
        <p class="tip" v-if="tip">{{tip}}</p>
      </el-form-item>
    </el-form>
    <div class="budget-pop-footer">
      <el-button size="small" type="info" plain @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="setBudget">确定</el-button>
    </div>
    <i v-if="slotType == 'icon'" class="i-icon icon-edit" slot="reference"></i>
    <button class="n-blue-btn" :class="btnClass" v-if="slotType == 'button'" slot="reference">{{btnText}}</button>
  </el-popover>
</template>
<script>
  import {changeDayBudget} from '../common/api.js';
  export default {
    name: 'edit-budget',
    props: {
      slotType: {
        type: String,
        default: 'icon'
      },
      btnText: String,
      btnClass: {
        type: String,
        default: 'plain'
      },
      tip: String,
      dayBudget: [Number, String]
    },
    data() {
      return {
        visible: false,
        budgetData: {
          type: this.dayBudget === 10000000000001 ? 0 : 1,
          budget: this.dayBudget === 10000000000001 ? '' : this.dayBudget
        },
        rules: {
          budget: [{
            type: 'number',
            trigger: 'change',
            min: 200,
            max: 10000000000000,
            message: '账户日预算为200～10兆元/天',
            required: true
          }]
        }
      }
    },
    watch: {
      dayBudget(val) {
        this.budgetLock = true;
        this.budgetData.type = val === 10000000000001 ? 0 : 1;
        this.budgetData.budget = val === 10000000000001 ? '' : this.dayBudget;
        this.$refs.budgetForm.clearValidate();
        this.$nextTick(() => {
          this.budgetLock = false;
        });
      },
      visible(val) {
        if (val && this.dayBudget) {
          location.href.includes('index.html') && this.$log('click', {
            pageLevel1: this.pageLevel1,
            pageLevel2: this.pageLevel2,
            pageLevel3: this.pageLevel3,
            element_name: 'account_budget_limit_next_step'
          });
          this.$log('expose', {
            pageLevel1: this.pageLevel1,
            pageLevel2: this.pageLevel2,
            pageLevel3: this.pageLevel3,
            element_name: 'adjust_account_budget_limit_adopt'
          });
        }
      }
    },
    created() {
      this.pageLevel1 = location.href.includes('index.html') ? 'account_homepage' : 'advertising_suggestion';
      this.pageLevel2 = location.href.includes('index.html') ? 'delivery_suggestion' : 'budget_adjustment';
      this.pageLevel3 = location.href.includes('index.html') ? 'delivery_suggestion' : 'budget_adjustment';
    },
    methods: {
      close() {
        this.visible = false;
        this.$emit('update-data');
      },
      setBudget() {
        this.dayBudget && this.$log('click', {
          pageLevel1: this.pageLevel1,
          pageLevel2: this.pageLevel2,
          pageLevel3: this.pageLevel3,
          element_name: 'adjust_account_budget_limit_adopt'
        });
        this.$refs.budgetForm.validate(async valid => {
          if (!valid) return;
          let budget = {
            settings: this.budgetData.type
          };
          if (this.budgetData.type === 1) {
            budget.newDayBudget = +this.budgetData.budget;
          }
          let data = await changeDayBudget(budget);
          if (data && data.success) {
            this.$emit('update-data', true);
            this.visible = false;
          }
        });
      }
    }
  }
</script>
<style lang="scss">
  .dashboard-budget {
    color: #333;
    &.el-popover {
      padding: 20px;
      border-radius: 14px;
      border: none;
    }
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 14px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: #000;
      .el-icon-close {
        cursor: pointer;
      }
    }
    .info-text {
      font-size: 14px;
      color: #9e9e9e;
    }
    .budget-pop-footer {
      padding-top: 2px;
      text-align: right;
      .el-button {
        border-radius: 32px;
      }
      .el-button--primary {
        background: #0052D9;
        border: none;
        &:hover {
          background: #3678e4;
        }
      }
      .el-button--info.is-plain {
        background: #F5F5F5;
        border: none;
        color: #000;
      }
    }
    .el-form-item {
      &.el-form-item--small {
        margin-bottom: 14px;
      }
      .el-form-item__content {
        line-height: 28px;
      }
      &.is-error {
        margin-bottom: 26px;
      }
      .el-radio__input.is-checked .el-radio__inner {
        border-color: #0052D9;
        background: #0052D9;
      }
      .el-input__inner:focus {
        border-color: #0052D9;
      }
      .el-form-item__content {
        .tip {
          font-size: 12px;
          color: #00000099;
        }
      }
    }
  }
</style>